<template>
  <div class="logout--inner"></div>
</template>

<script>
import { mapActions } from 'vuex'
import axios from 'axios'

export default {
  name: 'login',
  data () {
    return {
      user: { u: '', p: '' },
      userIsLoggedIn: false,
      logMessage: ''
    }
  },

  async created () {
    await this.logout()
    window.localStorage.clear()
    axios.defaults.headers.common['Authorization'] = `Bearer ${window.localStorage.token}`
    this.$router.push('/login')
  },

  methods: {
    ...mapActions('logins', ['logout'])
  }
}
</script>
<style>
  .log_message {
    text-align: center;
  }
</style>
